const initializedLinks = new WeakSet();

const getScrollTop = () => (
  window.pageYOffset
  || document.documentElement.scrollTop
  || document.body.scrollTop
  || 0
);

const setScrollTop = (value) => {
  window.scrollTo(0, value);
  document.documentElement.scrollTop = value;
  document.body.scrollTop = value;
};

const prefersReducedMotion = () => (
  typeof window.matchMedia === 'function'
  && window.matchMedia('(prefers-reduced-motion: reduce)').matches
);

const easeOutCubic = (progress) => 1 - Math.pow(1 - progress, 3);

const scrollToTop = (duration = 650) => {
  const start = getScrollTop();

  if (start <= 0 || prefersReducedMotion()) {
    setScrollTop(0);
    return;
  }

  const startedAt = window.performance?.now?.() || Date.now();

  const animate = (timestamp) => {
    const currentTime = timestamp || Date.now();
    const progress = Math.min((currentTime - startedAt) / duration, 1);
    const nextPosition = Math.round(start * (1 - easeOutCubic(progress)));

    setScrollTop(nextPosition);

    if (progress < 1) {
      window.requestAnimationFrame(animate);
      return;
    }

    setScrollTop(0);
  };

  window.requestAnimationFrame(animate);
};

const collectScrollTopLinks = (scope) => {
  const links = new Set();

  if (scope?.matches?.('[data-scroll-top]')) {
    links.add(scope);
  }

  if (typeof scope?.querySelectorAll === 'function') {
    scope.querySelectorAll('[data-scroll-top]').forEach((link) => {
      links.add(link);
    });
  }

  return links;
};

const initFooterScrollTop = (scope = document) => {
  collectScrollTopLinks(scope).forEach((link) => {
    if (initializedLinks.has(link)) {
      return;
    }

    initializedLinks.add(link);

    link.addEventListener('click', (event) => {
      event.preventDefault();
      scrollToTop();
    });
  });
};

initFooterScrollTop();
window.initFooterScrollTop = initFooterScrollTop;
